import React, { useMemo } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TrafficDisruptionItem from './TrafficDisruptionItem';
import {
  filterDisruptionsForStopLines,
  normalizeLineName,
} from './trafficLineFilter';

function TrafficDisruptionList({ disruptions = [], lineStyles = [], t }) {
  const lineStyleByName = useMemo(() => {
    const map = new Map();
    lineStyles.forEach((line) => {
      map.set(normalizeLineName(line.name), {
        color: line.color,
        textColor: line.textColor,
      });
    });
    return map;
  }, [lineStyles]);

  const stopLineNames = useMemo(
    () => lineStyles.map((line) => line.name).filter(Boolean),
    [lineStyles],
  );

  const visibleDisruptions = useMemo(
    () => filterDisruptionsForStopLines(disruptions, stopLineNames),
    [disruptions, stopLineNames],
  );

  if (visibleDisruptions.length === 0) {
    return (
      <Alert
        severity="info"
        icon={<InfoOutlinedIcon />}
        sx={{
          mx: 1.5,
          mt: 2,
          background: 'linear-gradient(135deg, #fff8e1, #fff3c4)',
          borderLeft: '5px solid',
          borderColor: 'warning.main',
          color: '#5d4037',
          borderRadius: 2,
          '& .MuiAlert-icon': { color: '#e65100' },
        }}
      >
        <AlertTitle sx={{ fontWeight: 800, letterSpacing: 1, textTransform: 'uppercase', color: '#e65100' }}>
          {t('schedule.trafficTitle')}
        </AlertTitle>
        {t('schedule.trafficMessage')}
      </Alert>
    );
  }

  return (
    <Box sx={{ mt: 2, mx: 1.5 }}>
      <Stack spacing={1}>
        {visibleDisruptions.map((d, idx) => (
          <TrafficDisruptionItem
            key={d.id || `${d.title || 'traffic'}-${d.start || ''}-${d.end || ''}-${idx}`}
            disruption={d}
            lineStyleByName={lineStyleByName}
          />
        ))}
      </Stack>
    </Box>
  );
}

export default TrafficDisruptionList;
